// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconLeftCarouselInactive: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="currentColor">
            <g fill="none" fillRule="evenodd">
                <circle cx="28" cy="28" r="28" fill="#FFF" />
                <polygon fill="currentColor" fillRule="nonzero" points="30 38 32.5 35.5 25 28 32.5 20.5 30 18 20 28" />
            </g>
        </svg>
    );
};

export default React.memo(IconLeftCarouselInactive);
